export const environment = {
  production: false,
  landingOnly: false,
  waitlistEnabled: true,
  apiUrl: 'https://api-test.nyzed.com/wedoapi',
  appVersion: '3.18.0',
  turnstileSiteKey: '0x4AAAAAADnnzP3OdP-wXg1U',
  googleMapsApiKey: 'AIzaSyC98PXlxq7nudj9bFe8yCGmcIcSHCjaCzE',
  googleMapsMapId: '391c3829dcf9375b7ac124e9',
  googleClientId: '733033560733-ddi6hs4s21fro33grfuugdbmto8et6bv.apps.googleusercontent.com'
};
